/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MigrationEligibility } from './MigrationEligibility';
import {
    MigrationEligibilityFromJSON,
    MigrationEligibilityFromJSONTyped,
    MigrationEligibilityToJSON,
    MigrationEligibilityToJSONTyped,
} from './MigrationEligibility';

/**
 * 
 * @export
 * @interface MigrationStatusDto
 */
export interface MigrationStatusDto {
    /**
     * Whether a newer template version applies to this form.
     * @type {boolean}
     * @memberof MigrationStatusDto
     */
    updateAvailable: boolean;
    /**
     * Template version the form currently reflects.
     * @type {number}
     * @memberof MigrationStatusDto
     */
    currentVersion?: number | null;
    /**
     * Highest published version of the source template.
     * @type {number}
     * @memberof MigrationStatusDto
     */
    latestVersion?: number | null;
    /**
     * 
     * @type {MigrationEligibility}
     * @memberof MigrationStatusDto
     */
    eligibility: MigrationEligibility;
}



/**
 * Check if a given object implements the MigrationStatusDto interface.
 */
export function instanceOfMigrationStatusDto(value: object): value is MigrationStatusDto {
    if (!('updateAvailable' in value) || value['updateAvailable'] === undefined) return false;
    if (!('eligibility' in value) || value['eligibility'] === undefined) return false;
    return true;
}

export function MigrationStatusDtoFromJSON(json: any): MigrationStatusDto {
    return MigrationStatusDtoFromJSONTyped(json, false);
}

export function MigrationStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrationStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'updateAvailable': json['updateAvailable'],
        'currentVersion': json['currentVersion'] == null ? undefined : json['currentVersion'],
        'latestVersion': json['latestVersion'] == null ? undefined : json['latestVersion'],
        'eligibility': MigrationEligibilityFromJSON(json['eligibility']),
    };
}

export function MigrationStatusDtoToJSON(json: any): MigrationStatusDto {
    return MigrationStatusDtoToJSONTyped(json, false);
}

export function MigrationStatusDtoToJSONTyped(value?: MigrationStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updateAvailable': value['updateAvailable'],
        'currentVersion': value['currentVersion'],
        'latestVersion': value['latestVersion'],
        'eligibility': MigrationEligibilityToJSON(value['eligibility']),
    };
}

